module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor_/tractor_4k_bake.png";